import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  Container,
  Card,
  CardContent
} from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import PasswordField from './PasswordField';
import apiClient from '../../services/api';
import PoweredByCredit from '../common/PoweredByCredit';

const AdminLogin = ({ onLoginSuccess }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (field) => (e) => {
    setCredentials(prev => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await apiClient.login(credentials);
      
      if (response.success) {
        // Store user data and auth token in localStorage
        localStorage.setItem('currentUser', JSON.stringify(response.data));
        localStorage.setItem('currentUserId', response.data.id);
        localStorage.setItem('currentUserPermissions', JSON.stringify(response.data));
        if (response.data.token) {
          localStorage.setItem('authToken', response.data.token);
        }
        
        // Call the success callback
        onLoginSuccess(response.data);
      } else {
        setError(response.error || 'Login failed');
      }
    } catch (error) {
      setError(error.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Card sx={{ width: '100%', maxWidth: 400 }}>
          <CardContent sx={{ p: 4 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
              <LoginIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
              <Typography variant="h4" component="h1" gutterBottom>
                Admin Login
              </Typography>
              <Typography variant="body2" color="text.secondary" textAlign="center">
                Sign in to access the admin panel
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Username"
                value={credentials.username}
                onChange={handleInputChange('username')}
                margin="normal"
                autoComplete="username"
                autoFocus
              />
              
              <PasswordField
                fullWidth
                label="Password"
                value={credentials.password}
                onChange={handleInputChange('password')}
                margin="normal"
                autoComplete="current-password"
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                disabled={loading}
                sx={{ mt: 3, mb: 2 }}
                startIcon={<LoginIcon />}
              >
                {loading ? 'Signing In...' : 'Sign In'}
              </Button>
            </form>


          </CardContent>
        </Card>
        <PoweredByCredit />
      </Box>
    </Container>
  );
};

export default AdminLogin;
